import {
	Stack,
	Typography,
	Box,
	styled,
	Switch,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import AccordionPanel from '../Accordion';

import CachedImage from "../../../../components/common/CachedImage";
import { FileApiServices } from "../../../../services/api/FileServiceClient";
import { ImagePath } from "../../../../assets/ImagePath";
import { getColorForRankAndRoles } from "../../../../utils/ColorMapping";
import EditprofileModal from "../../../../components/ui/Modals/Profile/editProfile";
import { ProfileAvatar } from "../ProfileAvtar";
import Chip from "../../../../components/ui/Chip";
import EditRoleDetails from "../EditRole";
import webSocketClientApi from "../../../../services/socket/wsApiServices";
import { uploadFileWithSignedUrl } from "../../../../services/FilesService";


const SubheadingTypography = styled(Typography)({
	fontWeight: "700",
	fontSize: "22px",
	fontFamily: 'Figtree-Regular'
});

const MentorInputWrapper = styled(Stack)({
	padding: "0.3rem 1rem",
	marginTop: "1.5rem",
	border: "1px solid #E7E7FF",
	width: "100%",
	borderRadius: "8px",
});

const CustomSwitch = styled((props) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 60,
	height: 26,
	padding: 0,
	"& .MuiSwitch-switchBase": {
		padding: 0,
		margin: 2,
		transitionDuration: "300ms",
		"&.Mui-checked": {
			transform: "translateX(34px)",
			color: "#fff",
			"& + .MuiSwitch-track": {
				backgroundColor: "#05bc52",
				opacity: 1,
				border: 0,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: 0.5,
			},
		},
		"&.Mui-focusVisible .MuiSwitch-thumb": {
			color: "#05bc52",
			border: "6px solid #fff",
		},
		"&.Mui-disabled .MuiSwitch-thumb": {
			color:
				theme.palette.mode === "light"
					? theme.palette.grey[100]
					: theme.palette.grey[600],
		},
		"&.Mui-disabled + .MuiSwitch-track": {
			opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
		},
	},
	"& .MuiSwitch-thumb": {
		boxSizing: "border-box",
		width: 22,
		height: 22,
	},
	"& .MuiSwitch-track": {
		borderRadius: 26 / 2,
		backgroundColor: "#E9E9EA",
		opacity: 1,
		transition: theme.transitions.create(["background-color"], {
			duration: 500,
		}),
	},
}));

const MentorInput = ({ mentor, handleChange, setMentor }) => {
	const updateMentorData = () => {
		const updatedStagedData = [{
			componentType: 'mentor',
			disabled: false,
			isNew: false,
			value: !mentor
		}];
		setMentor(!mentor);
		handleChange(updatedStagedData, 'mentor');
	};

	return (
		<MentorInputWrapper
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
		>
			<Typography variant="body1" sx={{ fontFamily: 'Figtree-Regular' }}>Would you like to be a Mentor</Typography>
			<CustomSwitch sx={{ m: 1 }} checked={!!mentor} onChange={() => updateMentorData()} />
		</MentorInputWrapper>
	);
};

const updateMediaValues = (media, incomingMedia) => {
	if (!Array.isArray(incomingMedia)) {
		return media;
	}

	return media.map(mediaItem => {
		const found = incomingMedia.find(inItem => inItem.socialNetwork === mediaItem.name);
		if (found) {
			return { ...mediaItem, value: found.socialURL };
		}
		return mediaItem;
	});
};


const ProfileLeftSection = (props) => {
	const { user, profileImage, handleStagedData, setTrackUnstagedChanges, loadProfilePic, setUploading, uploading, resetSectionFields, isDisabled, isModalSaving } = props;
	const selectedDomain = useSelector((state) => state.domain.selectedDomain);

	const [mentor, setMentor] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [data, setData] = useState({});

	useEffect(() => {
		if (user && user.mentor !== undefined) {
			setMentor(!!user.mentor);
		}
	}, [user]);


	const saveProfile = (eve, fromAddRole) => {
		let {
			phoneNumbers,
			emailAddress,
			userName,
			mentor,
			userCompanyName,
			nationality,
			addressLine1,
			city,
			state,
			country,
			postCode,
			userTimezone,
			visible,
			searchable,
			aboutMe,
		} = data;

		if (fromAddRole) {
			let newData = fromAddRole;
			newData["emailAddress"] = emailAddress || user.emailAddress;
			props.save(newData);
			return;
		}

		let pns = {};
		phoneNumbers.forEach((p) => {
			if (p.value && p.value.trim()) {
				pns[p.key] = p.value;
			}
		});

		if (!userName) {
			setData({ ...data, nameError: true });
			return;
		}

		let newData = {
			phoneNumbers: pns,
			userName,
			emailAddress,
			userCompanyName,
			mentor,
			nationality,
			address: {
				addressLine1,
				city,
				state,
				country,
				postCode,
			},
			userTimezone,
			visible,
			searchable,
			aboutMe,
		};
       
		setData({
			...data,
			disableCancel: true,
			isDirty: false,
		});
		props.save(newData);
	};

	const uploadPhoto = (e) => {
		let filesObj = e.target.files;
		if (!filesObj) {
			return;
		}
		setUploading(true);
		let payload = {
			"fileScope": "profilePic",
			"fileName": user?.userId + ".png",
			selectedDomain
		}
		webSocketClientApi.GetSignedUrlsForUpload(payload)
			.then((res) => {
				if (res?.signedThumbnailUrl) {
					uploadFileWithSignedUrl(res.signedThumbnailUrl, filesObj[0]);
					setUploading(false);
					loadProfilePic();
				}

			})
			.catch((error) => {
				console.error("Error in uploading group image", error);
				setUploading(false);
			})
	};

	const [aboutMe, setAboutMe] = useState([{ value: "", disabled: true }]);
	const [emailAddress, setEmailAddress] = useState([{ value: "", disabled: true }]);
	const [updatedMedia, setUpdatedMedia] = useState([]);
	const [isInitialized, setIsInitialized] = useState(false);

	const media = [{ id: 1, name: 'Instagram', value: '', icon: <Box component='img' src='/img/insta.svg' sx={{ width: '1.5rem' }} />, disabled: true },
	{ id: 2, name: 'X', value: '', icon: <Box component='img' src='/img/twitterIcon.png' sx={{ width: '1.5rem' }} />, disabled: true },
	{ id: 3, name: 'Facebook', value: '', icon: <FacebookIcon color="primary" />, disabled: true },
	{ id: 4, name: 'Linked In', value: '', icon: <LinkedInIcon style={{ color: '#0e76a8' }} />, disabled: true }];


	useEffect(() => {
		if (user) {
			setAboutMe([{ value: user.aboutMe || "", disabled: true }]);
			setEmailAddress([{ value: user.emailAddress || '', disabled: true }]);
			const updatedMedia = updateMediaValues(media, user.media);
			setUpdatedMedia(updatedMedia);
			setIsInitialized(true);
		}
	}, [user]);


	return (
		<Stack
			sx={{ width: "100%", padding: '1rem 1.5rem' }}
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
		>
			<ProfileAvatar
				user={user}
				uploading={uploading}
				profileImage={profileImage}
				uploadPhoto={uploadPhoto}
			/>
			<Stack flexDirection="row" gap={1} sx={{ mt: 2 }}>
				<SubheadingTypography>{user && user.userName ? user.userName : ""}</SubheadingTypography>
				<CachedImage
					imgKey="editicon"
					onClick={() => setShowEditModal(true)}
					style={{ cursor: "pointer" }}
					image={ImagePath.editIcon}
				/>
			</Stack>
			{user?.rankLevel2 && user?.rankLevel3 &&
				<Stack flexDirection="row" alignItems="center" gap={1} sx={{ mt: 1 }}>
					{(user?.rankLevel2) && (
						<Chip
							label={user?.rankLevel2}
							sx={{
								backgroundColor: getColorForRankAndRoles(user),
								color: "#fff",
								'& .MuiChipLabel': {
									fontWeight: 400,
									fontSize: '1rem',
									fontFamily: 'Figtree-Regular',
								},
							}}
						/>
					)}
					{(user?.rankLevel3) && (
						<Typography
							variant="body1"
							sx={{
								fontWeight: 400,
								fontSize: '1rem',
								fontFamily: 'Figtree-Regular',
							}}
						>
							{user?.rankLevel3}
						</Typography>
					)}
				</Stack>
			}

			<MentorInput mentor={mentor} handleChange={handleStagedData} setMentor={setMentor} />

			{showEditModal && (
				<EditprofileModal
					customDialogStyles={{ height: '41rem', width: '35rem', overflow: 'hidden' }}
					custompadding='3.125rem'
					open={showEditModal}
					enableCloseOnOutsideClick={false}
					onClose={() => setShowEditModal(false)}
					headerContent={"Edit"}
				>
					<EditRoleDetails
						user={user}
						closeModal={() => setShowEditModal(false)}
						save={(e, data) => saveProfile(e, data)}
						isDisabled={isDisabled}
						isModalSaving={isModalSaving}
					/>
				</EditprofileModal>
			)}
			{
				isInitialized &&
				<>
					<AccordionPanel
						setTrackUnstagedChanges={setTrackUnstagedChanges}
						handleStagedData={handleStagedData}
						title='About me'
						componentType='aboutMe'
						shudDeleteBtnRender={false}
						shudClearBtnRender={true}
						isAddButtonVisible={false}
						isEditSaveToggleVisible={true}
						initialFields={aboutMe}
						setIsSaveDisabled={props.setIsSaveDisabled}
						resetSectionFields={resetSectionFields}
					/>
					<AccordionPanel
						setTrackUnstagedChanges={setTrackUnstagedChanges}
						handleStagedData={handleStagedData}
						title='Email'
						componentType='emailAddress'
						shudDeleteBtnRender={false}
						shudClearBtnRender={false}
						isAddButtonVisible={false}
						isEditSaveToggleVisible={false}
						initialFields={emailAddress}
						setIsSaveDisabled={props.setIsSaveDisabled}
						resetSectionFields={resetSectionFields}
					/>
					<AccordionPanel
						setTrackUnstagedChanges={setTrackUnstagedChanges}
						handleStagedData={handleStagedData}
						title='Social'
						componentType='media'
						shudDeleteBtnRender={false}
						shudClearBtnRender={true}
						isAddButtonVisible={false}
						isEditSaveToggleVisible={true}
						initialFields={updatedMedia}
						setIsSaveDisabled={props.setIsSaveDisabled}
						resetSectionFields={resetSectionFields}
					/>
				</>
			}
		</Stack>
	);
};

export default ProfileLeftSection;
